module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "label-position": "left",
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "报警邮箱",
      "prop": "name"
    }
  }, [_c('el-input')], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("立即创建")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fafc498"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu-add.vue
// module id = 1106
// module chunks = 0